<template>
  <!-- <div class="serch_border">
    <div class="serchform">
      投资阶段：
      <a-tag :class="{'tag-active':''==projectStages}"  @click="postSerchData({'projectStage':''})">不限</a-tag>
      <a-tag :class="{'tag-active':'A'==projectStages}"  @click="postSerchData({'projectStage':'A'})" >种子期</a-tag>
      <a-tag :class="{'tag-active':'B'==projectStages}"  @click="postSerchData({'projectStage':'B'})" >初创期</a-tag>
      <a-tag :class="{'tag-active':'C'==projectStages}"  @click="postSerchData({'projectStage':'C'})" >成长期</a-tag>
      <a-tag :class="{'tag-active':'D'==projectStages}"  @click="postSerchData({'projectStage':'D'})" >成熟期</a-tag>


    </div>
  </div> -->
    <a-input-search
      style="margin-top:20px"
      v-model:value="companyNames"

      placeholder="请输入想要查询的企业名称"
      enter-button="立即搜索"
      size="large"
      @search="postSerchData({'companyName':companyNames})"
    />
  <div class="cont_body" style="height: 400px;">
    <div v-for="(item,key) in dataSource" :key="key" class="list_cont">
      <div class="list_img">
        <img :src="getImg(item.companyLogo)" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{item.companyName}}
          <!-- | <span v-if="item.typeEnterprise=='A'">种子期</span>
          <span v-if="item.typeEnterprise=='B'">初创期</span>
          <span v-if="item.typeEnterprise=='C'">成长期</span>
          <span v-if="item.typeEnterprise=='D'">成熟期</span> -->
        </h4>
        <P>统一社会信用代码：{{item.oraganizationCode}}</P>
        <P>营业收入规模(万元)：{{item.operatingIncomeScale}}</P>
      </div>
      <div class="list_cont_pay">
        <p>研发费用占营业收入比例：<span>{{item.rdExpensesPercentageRevenue}}</span>%</p>
        <p>软件著作权,实用新型授权量：<span>{{item.newSoftwareLicenseNumber}}</span>件</p>
        <p>高新技术产品收入占营业收入比例：<span>{{item.proportionRevenueProducts}}</span>%</p>
      </div>
    </div>
  </div>
  <!--分页-->
  <div class="pagination">
    <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
  </div>
    <LayoutFooter />
</template>
<script>
import { listMixin } from "@/mixins";
import {enterpriseThinkTank} from "@/api/integral";
import {file_service} from "@/api/adminService";
export default {
  name: 'investor',
  mixins: [listMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      role: null,
      guarantees:'',
      options:null,
      companyNames: '',
      projectStages: '', //投资阶段
      listUrl: enterpriseThinkTank.getPageList,
      queryParamFixed: {
        typeEnterprise: this.projectStages,
        companyName: this.companyNames,
       },
      current: 1,
      pageSize: 10,
    }
  },
  mounted() {
  },
	methods: {
    postSerchData(val){
      console.log(val)
        if(val.projectStage||val.projectStage==''){
          this.queryParamFixed.typeEnterprise = val.projectStage
          this.projectStages = val.projectStage
        }
        if(val.companyName||val.companyName==''){
          this.queryParamFixed.companyName = val.companyName
          this.companyNames = val.companyName
        }
      this.loadData()

    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  color:#b3b2b2;
  width:100%;
  margin-bottom: 16px;
  display: flex;
  &:hover {
    :deep(.ant-btn){
      color:#fff;
      border:1px solid #1890ff;
      background: #1890ff;
    }
  }
  .list_img{
    width: 80px;
    height: 80px;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 30px 20px 20px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  .list_cont_body{
    flex: 4;
    h4{
      margin-bottom: 20px;
    }
    p{
      word-break: break-all;
      overflow:hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:1;
    }
  }
  .list_cont_pay{
    flex: 3;
    padding-left: 40px;
    p{
      line-height: 35px;
      span{
        color:red
      }
    }
  }
  .list_botton{
    flex: 1;
  }
}

:deep(.ant-btn){
	border-radius: 0;
}
</style>
